import { useState } from 'react';
import generatePdf from '../utils/generatePdf';

function useFormSubmission(formRef, token, stage = 'stage_1') {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [submitError, setSubmitError] = useState('');

  const handleSubmit = async (formData, validate) => {
    setSubmitError('');
    
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      return { success: false, errors: validationErrors };
    }

    setLoading(true);
    try {
      const pdfBlob = await generatePdf(formRef.current);
      const submitData = new FormData();
      
      const filename = stage === 'stage_2' ? 'stage2-form.pdf' : 'form.pdf';
      submitData.append('pdf', pdfBlob, filename);
      
      const jsonData = {
        ...formData,
        token,
        ...(stage === 'stage_2' && { stage: 'stage_2' })
      };
      submitData.append('jsonData', JSON.stringify(jsonData));

      const res = await fetch('https://octopus.no-ms.dk/pre-project-form/submit-form', {
        method: 'POST',
        body: submitData,
      });
      
      if (!res.ok) {
        let errorMsg = 'Serverfejl ved indsendelse';
        try {
          const errorData = await res.json();
          errorMsg = errorData.detail || errorMsg;
        } catch (e) {
          // If response is not JSON, keep default errorMsg
        }
        throw new Error(errorMsg);
      }
      
      setSuccess(true);
      return { success: true };
    } catch (err) {
      const errorMessage = err.message || 'Uventet fejl';
      setSubmitError(errorMessage);
      return { success: false, error: errorMessage };
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    success,
    submitError,
    handleSubmit,
    setSuccess,
    setSubmitError
  };
}

export default useFormSubmission;